import { useState } from "react";
import { MobileHeader } from "./MobileHeader";
import { MobileNavigation } from "./MobileNavigation";
import { PageTransition } from "./PageTransition";
import { MobileAIChat } from "./MobileAIChat";
import { useIsMobile } from "@/hooks/use-mobile";
import { NavigationProgress } from "./mobile/NavigationProgress";

interface MobileLayoutProps {
  children: React.ReactNode;
  title?: string;
  showBack?: boolean;
  hideBottomNav?: boolean;
  transparentHeader?: boolean;
  enableBackGesture?: boolean;
  breadcrumb?: string;
}

export function MobileLayout({
  children,
  title,
  showBack = true,
  hideBottomNav = false,
  transparentHeader = false,
  enableBackGesture = true,
  breadcrumb
}: MobileLayoutProps) {
  const [isAIChatOpen, setIsAIChatOpen] = useState(false);
  const isMobile = useIsMobile();

  // Only render on mobile
  if (!isMobile) {
    return null;
  }

  return (
    <>
      {/* Navigation Progress Bar */}
      <NavigationProgress />

      {/* Mobile Header */}
      <MobileHeader
        title={title}
        showBack={showBack}
        transparent={transparentHeader}
        breadcrumb={breadcrumb}
      />

      {/* Content with Page Transition */}
      <PageTransition
        className="md:hidden pt-14 pb-24 min-h-[100dvh] bg-background"
        enableBackGesture={enableBackGesture}
      >
        {children}
      </PageTransition>

      {/* Bottom Navigation with integrated FAB and AI action */}
      {!hideBottomNav && <MobileNavigation onOpenAIChat={() => setIsAIChatOpen(true)} />}

      {/* AI Chat Sheet */}
      <MobileAIChat open={isAIChatOpen} onOpenChange={setIsAIChatOpen} />
    </>
  );
}
